import { getLabDetails, ILabIndex } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getPageProps, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
import { GetStaticPropsResult } from 'next';

export default function LabIndex({ layout, page, params }: PageProps<ILabIndex>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.media?.url,
      })} />
    </>
  );
}

LabIndex.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext): Promise<GetStaticPropsResult<PageProps<ILabIndex>>> {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<ILabIndex>('lab_index', id, market, locale, context);

  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const components = page.components || [];
  components.push({
    schema: 'block_hero_text',
    title: page.title,
    paragraph1: page.paragraph1,
    paragraph2: page.paragraph2,
  });
  components.push({
    schema: 'block_lab_index',
    items: await getLabDetails({ market, locale, sort: 'title' }),
  });
  page.components = components;

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    /*
    * Next.js will attempt to re-generate the page when a request comes in at most once every 60 seconds
    */
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('lab_index');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
